module.exports = __webpack_public_path__ + "static/media/Search Sanctions Kişi ID.dca91210.xlsx";